import type { Batch } from '../api/business/types';
import type { Language } from '../i18n/Language';
import type { Translate } from '../i18n/translate';

import { formatDate } from './format';

/** How a batch is named on screen: its expiry and lot, or "no batch" for the product's plain stock. */
export const batchLabel = (
  batch: Pick<Batch, 'expiryDate' | 'lotNumber'>,
  t: Translate,
  language: Language,
): string => {
  const parts: Array<string> = [];

  if (batch.expiryDate) {
    parts.push(t('batch.expires', { date: formatDate(batch.expiryDate, language) }));
  }

  if (batch.lotNumber) {
    parts.push(t('batch.lot', { lot: batch.lotNumber }));
  }

  return parts.length > 0 ? parts.join(' · ') : t('batch.plain');
};
